<div class="global-results-managers">
  <ngb-accordion #acc="ngbAccordion" class="actions-accordion" *ngIf="modelResult">
    <ngb-panel *ngFor="let elem of modelResult">
      <ng-template ngbPanelHeader>
        <button ngbPanelToggle class="accordion-button bg-light">
          <div class="supervisor">
            <strong>{{elem.Name}}</strong>
          </div>
          <div class="remuneracion">
            <span class="label_data">Remuneración</span><br>
            {{elem.TotalPrice | currency:'EUR'}}
          </div>
        </button>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="table__resume table-responsive-lg">
          <table class="table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Unidades vendidas</th>
                <th>Remuneración</th>
                <th>€/Unidades</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let elem2 of elem.Detail">
                <td>{{elem2.ProductType}}</td>
                <td class="table-active w-12">{{elem2.TotalUnits}}</td>
                <td class="table-active w-12">{{elem2.TotalPrice | currency:'EUR'}}</td>
                <td class="table-active w-12">{{elem2.Price | currency:'EUR'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>